module.exports = __webpack_public_path__ + "img/pic1.b82fa47d.png";